module.exports = __webpack_public_path__ + "img/102.7fb2aa4a.webp";